import React from "react";
import Slider from "react-slick";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../i18n";
// import SlidingText from "./SlidingText";

import banner1 from "../assets/banners/banner1.jpg";
import banner2 from "../assets/banners/banner2.jpg";
import banner3 from "../assets/banners/banner3.jpg";

const slides = [

    {
      title: "banner1_title",
      subtitle: "banner1_subtitle",
      buttonText: "banner1_button",
      image: banner1,
    },
    {
      title: "banner2_title",
      subtitle: "banner2_subtitle",
      buttonText: "banner2_button",
      image: banner2,
    },
    {
      title: "banner3_title",
      subtitle: "banner3_subtitle",
      buttonText: "banner3_button",
      image: banner3,
    },
  
  
];

const BannerSlider = () => {
  const { t } = useTranslation();

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    pauseOnHover: true,
  };

  return (
    <section id="Home" className="py-5 bg-gradient-to-br from-blue-100 via-white to-pink-100 px-0">
    <div className="w-full overflow-hidden">
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <div key={index} className="relative h-[100vh] w-full">
            <img
              src={slide.image}
              alt={`slide-${index}`}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/50 flex flex-col items-center justify-center text-center px-4">
              <motion.h1
                initial={{ y: -50, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.8 }}
                className="text-white text-4xl md:text-6xl font-bold mb-4 leading-tight"
              >
                {t(slide.title)}
              </motion.h1>
              <motion.p
                initial={{ y: 50, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 1 }}
                className="text-white text-lg md:text-2xl mb-6"
              >
                {t(slide.subtitle)}
              </motion.p>
              <motion.button
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
                className="bg-gradient-to-r from-pink-500 to-red-500 text-white px-6 py-3 rounded-full text-lg font-semibold shadow-lg hover:shadow-2xl transition"
                onClick={() => alert(t(slide.buttonText))}
              >
                {t(slide.buttonText)}
              </motion.button>
            </div>
          </div>
        ))}
      </Slider>
    </div>
    {/* <SlidingText/> */}
    </section>
  );
  
};
export default BannerSlider;
